import usStates from "../data/us-states.json";

const getState = (stateName) => {
    return usStates.features.find(state => state.properties.name === stateName);
}
export default getState;